import {z} from 'zod'
import {HexColor} from '../color/index.js'
import {Workdays} from './Workdays.js'
import {ProjectId} from './ProjectId.js'

export const Project = z.object({
  id: ProjectId,
  name: z.string().min(1),
  color: HexColor,
  archivedTime: z.string().nullish(),
  workdays: Workdays,
})
export type Project = z.infer<typeof Project>
